"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketItemToJSON = exports.BasketItemFromJSONTyped = exports.BasketItemFromJSON = exports.instanceOfBasketItem = void 0;
var ProductType_1 = require("./ProductType");
/**
 * Check if a given object implements the BasketItem interface.
 */
function instanceOfBasketItem(value) {
    var isInstance = true;
    isInstance = isInstance && "productType" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "distributionId" in value;
    isInstance = isInstance && "adPlat" in value;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
exports.instanceOfBasketItem = instanceOfBasketItem;
function BasketItemFromJSON(json) {
    return BasketItemFromJSONTyped(json, false);
}
exports.BasketItemFromJSON = BasketItemFromJSON;
function BasketItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productType': (0, ProductType_1.ProductTypeFromJSON)(json['productType']),
        'productId': json['productId'],
        'distributionId': json['distributionId'],
        'adPlat': json['adPlat'],
        'token': json['token'],
    };
}
exports.BasketItemFromJSONTyped = BasketItemFromJSONTyped;
function BasketItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productType': (0, ProductType_1.ProductTypeToJSON)(value.productType),
        'productId': value.productId,
        'distributionId': value.distributionId,
        'adPlat': value.adPlat,
        'token': value.token,
    };
}
exports.BasketItemToJSON = BasketItemToJSON;
